import config from "@/config/index";
import api from '../../utils/axios-util';
import * as calldetails from "../mutation-types";
import moment from 'moment'
// import { log } from "console";
const state = config.overall_report_state;
var from_date = '';
var to_date = '';

var getters = {

    calldetails_data: () => config.overall_report_state.calldetails.report,
    effectiveabandon_data: () => config.overall_report_state.effectiveabandon.report,
    systemcallsummary_data: () => config.overall_report_state.systemcallsummary.report,
    recording_date: () => config.overall_report_state.recordingreport.report,
    filter: () => config.overall_report_state.filter,
    filters: () => config.overall_report_state.filters,
    missedcallreport: () => config.overall_report_state.missedcallreport.report,
    dropedcallreport: () => config.overall_report_state.dropedcallreport.report,
    auth0accessToken: () => config.auth0.auth0.accessToken,
    agentActivity: () => config.overall_report_state.agent_activity_report.report,
    watsAppReport: () => config.overall_report_state.watsAppReport.report,
    ticketReport: () => config.overall_report_state.ticketReport.report,
    fromdate: () => config.overall_report_state.filters.fromdate,

    performance_report: () => config.overall_report_state.performance_report.report,
    queueSummary: () => config.overall_report_state.queueSummaryReport.report,
    agentPauseReport: () => config.overall_report_state.agent_pause_report.report,
    agentDispoReport: () => config.overall_report_state.agent_dispo_report.report

}
const mutations = {
    [calldetails.SYSTEMCALLSUMMARY]: (state, payload) => {

        state.systemcallsummary.report = payload;
    },

    [calldetails.CALLDETAILS]: (state, payload) => {
        state.calldetails.report = payload;
    },
    [calldetails.EFFECTIVEABANDON]: (state, payload) => {
        state.effectiveabandon.report = payload;
    },
    [calldetails.RECORDINGDETAILS]: (state, payload) => {
        state.recordingreport.report = payload;
    },
    [calldetails.FILTERFROMDATE]: (state, payload) => {
        state.filters.fromdate = payload;

    },
    [calldetails.FILTER_TODATE]: (state, payload) => {

        state.filters.todate = payload;

    },
    [calldetails.ACTION_FROMDATE]: (state, payload) => {
        state.filter.fromdate = payload;
        state.filter.filter_process = true;
    },
    [calldetails.ACTION_TODATE]: (state, payload) => {
        state.filter.todate = payload;
        state.filter.filter_process = true;
    },
    [calldetails.FILTER_AGENT]: (state, payload) => {
        state.filter.agent = payload.agent;
    },
    [calldetails.CALL_TRANSCRIPTION]: (state, payload) => {
        state.filter.calltrans = payload.calltrans;
    },
    [calldetails.FILTER_TEMPLATE]: (state, payload) => {
        state.filter.template = payload.template;
    },
    [calldetails.FILTER_TYPE]: (state, payload) => {
        state.filter.type = payload.type;
    },
    [calldetails.FILTER_PHONE]: (state, payload) => {
        state.filter.phone = payload.phone;
    },

    [calldetails.FILTER_LISTID]: (state, payload) => {
        state.filter.list_id = payload.list_id;
    },
    [calldetails.FILTER_CAMPAIGN]: (state, payload) => {
        state.filter.campaign = payload.campaign;
    },
    [calldetails.FILTER_EXTENSION]: (state, payload) => {
        state.filter.extension = payload.extension;

    },
    [calldetails.FILTER_GROUP]: (state, payload) => {
        state.filter.group = payload.group;
    },
    [calldetails.FILTER_STATION]: (state, payload) => {
        state.filter.station = payload.station;
    },
    [calldetails.FILTER_DID]: (state, payload) => {
        state.filter.did = payload.did;
    },
    [calldetails.FILTER_QUEUE]: (state, payload) => {
        state.filter.queue = payload.queue;
    },
    [calldetails.FILTER_DISPO]: (state, payload) => {
        state.filter.dispo = payload.dispo;
    },
    [calldetails.FILTER_STATUS]: (state, payload) => {
        state.filter.status = payload.status;
    },

    [calldetails.DATE]: (state, payload) => {
        state.filter.fromdate = payload.from_date;
        state.filter.todate = payload.to_date;
    },
    [calldetails.MISSEDCALLDETAILS]: (state, payload) => {
        state.missedcallreport.report = payload;
    },
    [calldetails.DROPEDCALLDETAILS]: (state, payload) => {
        state.dropedcallreport.report = payload;
    },
    [calldetails.FILTER_LAST_APP]: (state, payload) => {
        state.filters.last_app = payload.last_app;
    },
    [calldetails.AGENT_ACTIVITY_REPORTS]: (state, payload) => {
        state.agent_activity_report.report = payload;
    },
    [calldetails.CAMPAIGN_LISTS]: (state, payload) => {
        var campaign_payload = [];
        for (var i = 0; i < payload.data.count; i++) {
            campaign_payload.push(payload.data.data[i].campaign_name);
        }
        state.filters.campaign = campaign_payload;
    },
    [calldetails.FILTER_Event]: (state, payload) => {
        state.filter.event = payload.event;
    },
    [calldetails.AGENT_CAMPAIGN]: (state, payload) => {
        state.filter.campaign = payload.campaign;
    },
    [calldetails.Performance_report]: (state, payload) => {
        state.performance_report.report = payload;
    },
    [calldetails.queueSummaryReport]: (state, payload) => {
        state.queueSummaryReport.report = payload;
    },
    [calldetails.FILTER_UNIQUEID]: (state, payload) => {
        state.filter.uniqueid = payload.uniqueid;
    },
    [calldetails.AGENT_PAUSE_REPORT]: (state, data) => {
        state.agent_pause_report.report = data;
    },
    [calldetails.AGENT_DISPO_REPORT]: (state, data) => {
        state.agent_dispo_report.report = data;
    },
    [calldetails.WatsAppReport]: (state, data) => {
        state.watsAppReport.report = data;
    },
    [calldetails.TicketReport]: (state, data) => {
        state.ticketReport.report = data;
    },
    [calldetails.DISPOSITION_LIST]: (state, payload) => {
        state.filters.dispo_status = payload;
    },
    [calldetails.SUBDISPOSITION_LIST]: (state, payload) => {
        state.filters.subdispo_status = payload;
    },
    [calldetails.CommitNothing]: () => { }
};

const actions = {


    systemcallsummary({ commit }, payload) {
        return new Promise((resolve, reject) => {
            try {
                from_date = state.filters.fromdate;
                to_date = state.filters.todate;
                if (payload.descending == null) {
                    payload.descending = false;
                }
                let campaign
                let campaigns = JSON.parse(localStorage.getItem("Team"));
                if (campaigns.length === 0) {
                    campaign = ""
                }
                else {
                    let campaigndata = [... new Set(campaigns.map((elm)=>{
                        return elm.campaign.map((campaign) => campaign.name);
                    }).flat())]
                    campaign = campaigndata.join(',');
                }
                const requestBody = {
                    fromdate: from_date,
                    todate: to_date,
                    take: payload.take || 0,
                    skip: payload.skip || 0,
                    descending: payload.descending,
                    datetype: payload.datetype,
                    campaign: campaign
                };
                api.post('/CallSummary_fetch', requestBody)
                    .then(response => {
                        commit(calldetails.SYSTEMCALLSUMMARY, response.data.data);
                        resolve(response.data)
                    }).catch(function (error) {
                        commit(calldetails.SYSTEMCALLSUMMARY, []);
                        resolve(error)
                    });

            } catch (error) {
                commit(calldetails.SYSTEMCALLSUMMARY, []);
                reject(error);
            }
        })
    },
    async calldetails({ commit }, payload) {
        return new Promise((resolve, reject) => {
            try {
                from_date = state.filters.fromdate;
                to_date = state.filters.todate;
                let agent = '';
                let queue = '';
                let campaign = '';
                let calltype = '';
                let status = '';
                let dispo_status = '';
                let team = '';
                const campaigns = JSON.parse(localStorage.getItem("Team"));
                let team_user = ''
                if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
                }
                else {
                    let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
                    team_user = groupUsers.join(',');
                }
                team = Array.isArray(payload.teams_name) ? payload.teams_name.join(',') : payload.teams_name;
                agent = Array.isArray(state.filter.agent)
                    ? state.filter.agent.join(",")
                    : state.filter.agent || "";

                queue = Array.isArray(state.filter.queue)
                    ? state.filter.queue.join(",")
                    : state.filter.queue || "";

                campaign = Array.isArray(state.filter.campaign)
                    ? state.filter.campaign.join(",")
                    : state.filter.campaign || "";

                calltype = Array.isArray(state.filter.type)
                    ? state.filter.type.join(",")
                    : state.filter.type || "";

                status = Array.isArray(state.filter.status)
                    ? state.filter.status.join(",")
                    : state.filter.status || "";

                dispo_status = Array.isArray(state.filter.dispo)
                    ? state.filter.dispo.join(",")
                    : state.filter.dispo || "";

                if (payload.descending == null) {
                    payload.descending = false;
                }
                if (payload.Durationtype === "Hold Time") {
                    payload.Durationtype = "hold_time"
                } else if (payload.Durationtype === "Talk Time") {
                    payload.Durationtype = "talk_time"
                } else if (payload.Durationtype === "Acw Time") {
                    payload.Durationtype = "acw_time"
                }
                const requestBody = {
                    from_call_date: from_date,
                    to_call_date: to_date,
                    phone: state.filter.phone || "",
                    list_id: state.filter.list_id || "",
                    campaign: campaign,
                    queue: queue,
                    agent: agent,
                    call_type: calltype,
                    status: status,
                    take: payload.take,
                    skip: payload.skip,
                    station: state.filter.station || "",
                    dispo_status: dispo_status,
                    descending: payload.descending,
                    did_number: state.filter.did || "",
                    uniqueid: state.filter.uniqueid || "",
                    template_name: state.filter.template,
                    team_user: team_user,
                    operator: payload.operator || "",
                    value: payload.value || "",
                    Durationtype: payload.Durationtype || "",
                    answerStatus: payload.answerStatus || "",
                    team: team,
                };
                //+ "&list_id=" + state.filter.list_id 
                api.post("/CallLogfetch", requestBody)
                    .then(response => {
                        commit(calldetails.CALLDETAILS, response.data.data);
                        resolve(response.data);
                    })
                    .catch(function (error) {
                        commit(calldetails.CALLDETAILS, []);
                        resolve(error);
                    });

            } catch (error) {
                commit(calldetails.CALLDETAILS, []);
                reject(error);
            }
        })
    },

    effectiveabandon({ commit, state }, payload) {
        return new Promise((resolve, reject) => {
            try {
                from_date = state.filters.fromdate;
                to_date = state.filters.todate;
                if (payload.descending == null) {
                    payload.descending = false;
                }
                let queue = '';
                queue = Array.isArray(state.filter.queue)
                    ? state.filter.queue.join(",")
                    : state.filter.queue || "";
                let campaign
                let campaigns = JSON.parse(localStorage.getItem("Team"));
                if (campaigns.length === 0) {
                    campaign = ""
                }
                else {
                    let campaigndata = [... new Set(campaigns.map((elm)=>{
                        return elm.campaign.map((campaign) => campaign.name);
                    }).flat())]
                    campaign = campaigndata.join(',');
                }
                const requestBody = {
                    from_call_date: from_date,
                    to_call_date: to_date,
                    queue: queue,
                    phone: state.filter.phone || "",
                    descending: payload.descending,
                    take: payload.take || 10,
                    skip: payload.skip || 0,
                    campaign: campaign
                };
                api.post('/EffectiveAbandonfetch', requestBody)
                    .then(response => {
                        commit(calldetails.EFFECTIVEABANDON, response.data.data);
                        resolve(response.data)
                    }).catch(function (error) {
                        commit(calldetails.EFFECTIVEABANDON, []);
                        resolve(error)
                    });

            } catch (error) {
                commit(calldetails.EFFECTIVEABANDON, []);
                reject(error);
            }
        })
    },



    fromdate({ commit }, payload) {
        commit('FILTERFROMDATE', payload);

    },
    todate({ commit }, payload) {
        commit('FILTER_TODATE', payload);
    },

    missedcallreports({ commit }, payload) {
        from_date = state.filters.fromdate;
        to_date = state.filters.todate;
        const descending = payload.descending == null ? false : payload.descending;
        let queue = '';
        queue = Array.isArray(state.filter.queue)
            ? state.filter.queue.join(",")
            : state.filter.queue || "";
        let campaign
        let campaigns = JSON.parse(localStorage.getItem("Team"));
        if (campaigns.length === 0) {
            campaign = ""
        }
        else {
            let campaigndata = [... new Set(campaigns.map((elm)=>{
                return elm.campaign.map((campaign) => campaign.name);
            }).flat())]
            campaign = campaigndata.join(',');
        }
        const requestBody = {
            fm_date_time: from_date,
            to_date_time: to_date,
            queue: queue,
            did_number:state.filter.did,
            phone: state.filter.phone || "",
            descending: descending,
            last_app: state.filters.last_app,
            take: payload.take || 10,
            skip: payload.skip || 0,
            campaign: campaign
        };
        return new Promise((resolve, reject) => {
            try {
                if (payload.descending == null) {
                    payload.descending = false;
                }
                api.post('/missedcallreports', requestBody)
                    .then(response => {
                        commit(calldetails.MISSEDCALLDETAILS, response.data.data);
                        resolve(response.data)
                    }).catch(function (error) {
                        commit(calldetails.MISSEDCALLDETAILS, []);
                        resolve(error)
                    });
            } catch (error) {
                commit(calldetails.MISSEDCALLDETAILS, []);
                reject(error);
            }
        })
    },

    dropedcallreports({ commit }, payload) {
        let current_time = moment(new Date()).format().split('T')[1].split('+')[0]
        from_date = state.filters.fromdate;
        to_date = state.filters.todate;
        if (from_date.length == 10) {
            from_date += ' ' + current_time;
        }
        if (to_date.length == 10) {
            to_date += ' ' + current_time;
        }
        let agent = '';
        let queue = '';
        const campaigns = JSON.parse(localStorage.getItem("Team"));
        let team_user = ''
        if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
        }
        else {
            let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
            team_user = groupUsers.join(',');
        }
        agent = Array.isArray(state.filter.agent)
            ? state.filter.agent.join(",")
            : state.filter.agent || "";

        queue = Array.isArray(state.filter.queue)
            ? state.filter.queue.join(",")
            : state.filter.queue || "";

        const requestBody = {
            from_date: from_date,
            to_date: to_date,
            agent: agent,
            queue: queue,
            extension: state.filter.extension,
            phone_number: state.filter.phone || "",
            uniqueid: state.filter.uniqueid || "",
            take: payload.take || 10,
            skip: payload.skip || 0,
            team_user: team_user,
        };
        console.log(requestBody, "dropedcalsssssssssssss");

        return new Promise((resolve, reject) => {
            try {
                api.post("/dropedcallreports", requestBody)
                    .then(response => {
                        resolve(response.data)
                        commit(calldetails.DROPEDCALLDETAILS, response.data.data);
                    }).catch(function (error) {
                        commit(calldetails.DROPEDCALLDETAILS, []);
                        resolve(error)
                    });
            } catch (error) {
                commit(calldetails.DROPEDCALLDETAILS, []);
                reject(error);
            }
        })
    },
    async agentactivityreports({ commit, state }, payload) {
        const from_date = state.filters.fromdate;
        const to_date = state.filters.todate;
        let event = '';
        let agent = '';
        let team_user = '';
        let eventdata = '';
        let team = '';


        // if (!state.filter.agent || state.filter.agent.length === 0) {
        const campaigns = JSON.parse(localStorage.getItem("Team"));
        if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
        }
        else if(campaigns.length > 0) {
            let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
            team_user = groupUsers.join(',');
                team = campaigns.map(elm=> elm.name).join(',');  
        }
        // } else {
        //     agent = state.filter.agent;
        // }
        const descending = payload.descending == null ? false : payload.descending;

        agent = Array.isArray(state.filter.agent)
            ? state.filter.agent.join(",")
            : state.filter.agent || "";

        eventdata = Array.isArray(payload.event_data)
            ? payload.event_data.join(",")
            : payload.event_data || "";

        event = Array.isArray(state.filter.event)
            ? state.filter.event.join(",")
            : state.filter.event || "";


        const requestBody = {
            fm_date: from_date,
            to_date: to_date,
            agent: agent,
            team_user: team_user,
            campaign: state.filter.campaign || '',
            event: event,
            event_data: eventdata,
            take: payload.take || 0,
            skip: payload.skip || 0,
            descending: descending,
            team: team
        };

        return new Promise((resolve, reject) => {
            try {
                api.post('/agentActivity', requestBody)
                    .then(response => {
                        commit(calldetails.AGENT_ACTIVITY_REPORTS, response.data.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        commit(calldetails.AGENT_ACTIVITY_REPORTS, []);
                        resolve(error);
                    });
            } catch (error) {
                commit(calldetails.AGENT_ACTIVITY_REPORTS, []);
                reject(error);
            }
        });
    },
    agentPauseReports({ commit }, payload) {
        const from_date = state.filters.fromdate;
        const to_date = state.filters.todate;
        let agent = '';
        let team_user = ''
        let team=''
        const campaigns = JSON.parse(localStorage.getItem("Team"));
        if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
        }
        else if(campaigns.length > 0) {
            let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
            team_user = groupUsers.join(',');
            team = campaigns.map(elm=> elm.name).join(',');    
        }
        agent = Array.isArray(state.filter.agent)
            ? state.filter.agent.join(",")
            : state.filter.agent || "";

        const requestBody = {
            fm_date: from_date,
            to_date: to_date,
            take: payload.take || 0,
            skip: payload.skip || 0,
            agent: agent,
            descending: payload.descending == null ? false : payload.descending,
            team_user: team_user,
            team :team
        };
        return new Promise((resolve, reject) => {
            try {
                api.post('/break/report', requestBody)
                    .then(response => {
                        commit(calldetails.AGENT_PAUSE_REPORT, response.data.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        commit(calldetails.AGENT_PAUSE_REPORT, []);
                        resolve(error);
                    });
            } catch (error) {
                commit(calldetails.AGENT_PAUSE_REPORT, []);
                reject(error);
            }
        });
    },
    agentDispoReports({ commit }, payload) {
        from_date = state.filters.fromdate;
        to_date = state.filters.todate;
        let agent = '';
        let team_user = ''
        let team =''
        const campaigns = JSON.parse(localStorage.getItem("Team"));
        if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
        }
        else if(campaigns.length > 0) {
            let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
            team_user = groupUsers.join(',');
            team = campaigns.map(elm=> elm.name).join(',');    
        }
        agent = Array.isArray(state.filter.agent)
            ? state.filter.agent.join(",")
            : state.filter.agent || "";

        const requestBody = {
            fm_date: from_date,
            to_date: to_date,
            take: payload.take || 0,
            skip: payload.skip || 0,
            agent: agent,
            descending: payload.descending == null ? false : payload.descending,
            team_user: team_user,
            team : team
        };

        return new Promise((resolve, reject) => {
            try {
                if (payload.descending == null) {
                    payload.descending = false;
                }
                api.post('/dispo/report', requestBody)
                    .then(response => {
                        commit(calldetails.AGENT_DISPO_REPORT, response.data.data);
                        resolve(response.data);
                    }).catch(function (error) {
                        commit(calldetails.AGENT_DISPO_REPORT, []);
                        resolve(error);
                    });
            } catch (error) {
                commit(calldetails.AGENT_DISPO_REPORT, []);
                reject(error);
            }
        })
    },
    type({ commit }, payload) {
        commit(calldetails.FILTER_TYPE, { type: payload })
    },

    exportdatafetch({ commit }, payload) {

        if (payload.calldetail == 'exportchatdetail') {
            return new Promise((resolve, reject) => {
                try {
                    api.post(`/chatlogfetch`)
                        .then(response => {
                            // const chatlog = response.data.data;
                            // commit(mutation_type.Chatlog, chatlog);
                            resolve(response);
                        });
                } catch (error) {
                    reject(error);
                }
            });
        }

        if (payload.calldetail == 'exportCallDetail') {
            return new Promise((resolve, reject) => {
                try {
                    from_date = state.filters.fromdate;
                    to_date = state.filters.todate;
                    let agent = '';
                    let queue = '';
                    let campaign = '';
                    let calltype = '';
                    let status = '';
                    let dispo_status = '';
                    const campaigns = JSON.parse(localStorage.getItem("Team"));
                    let team_user = ''
                    if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
                    }
                    else {
                        let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
                        team_user = groupUsers.join(',');
                    }

                    let team = '';
                    team = Array.isArray(payload.team_name) ? payload.team_name.join(',') : payload.team_name;
                    agent = Array.isArray(state.filter.agent)
                        ? state.filter.agent.join(",")
                        : state.filter.agent || "";

                    queue = Array.isArray(state.filter.queue)
                        ? state.filter.queue.join(",")
                        : state.filter.queue || "";

                    campaign = Array.isArray(state.filter.campaign)
                        ? state.filter.campaign.join(",")
                        : state.filter.campaign || "";

                    calltype = Array.isArray(state.filter.type)
                        ? state.filter.type.join(",")
                        : state.filter.type || "";

                    status = Array.isArray(state.filter.status)
                        ? state.filter.status.join(",")
                        : state.filter.status || "";

                    dispo_status = Array.isArray(state.filter.dispo)
                        ? state.filter.dispo.join(",")
                        : state.filter.dispo || "";

                    const requestBody = {
                        from_call_date: from_date,
                        to_call_date: to_date,
                        phone: state.filter.phone || "",
                        list_id: state.filter.list_id || "",
                        campaign: campaign,
                        queue: queue,
                        agent: agent,
                        call_type: calltype,
                        status: status,
                        station: state.filter.station || "",
                        dispo_status: dispo_status,
                        descending: payload.descending,
                        did_number: state.filter.did || "",
                        uniqueid: state.filter.uniqueid || "",
                        template_name: state.filter.template,
                        team_user: team_user,
                        operator: payload.operator || "",
                        value: payload.value || "",
                        Durationtype: payload.Durationtype || "",
                        answerStatus: payload.answerStatus || "",
                        team: team,
                    };
                    api.post("/CallLogfetch", requestBody)
                        .then(response => {
                            console.log(requestBody, "sakthi3333333333");

                            resolve(response.data.data);
                        }).catch(function (error) {
                            resolve(error);
                        })
                } catch (error) {
                    reject(error);
                }
            })
        }
        if (payload.calldetail == 'exportrecordigdetails') {
            from_date = state.filters.fromdate;
            to_date = state.filters.todate;
            let agent = '';
            let calltype = '';
            const campaigns = JSON.parse(localStorage.getItem("Team"));
            let team_user = ''
            if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
            }
            else {
                let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
                team_user = groupUsers.join(',');
            }
            let team = '';
            team = Array.isArray(payload.team_name) ? payload.team_name.join(',') : payload.team_name;

            agent = Array.isArray(state.filter.agent)
                ? state.filter.agent.join(",")
                : state.filter.agent || "";

            calltype = Array.isArray(state.filter.type)
                ? state.filter.type.join(",")
                : state.filter.type || "";

            const requestBody = {
                fromdate: from_date,
                todate: to_date,
                campaign: state.filter.campaign,
                station: state.filter.station,
                phone_number: state.filter.phone,
                call_type: calltype,
                team_user: team_user,
                agent: agent,
                descending: payload.descending,
                uniqueid: state.filter.uniqueid,
                operator: payload.operator,
                value: payload.value,
                dispo: payload.dispo,
                subdispo: payload.subdispo,
                team: team

            }
            return new Promise((resolve, reject) => {
                try {
                    if (state.filter.agent === '' || state.filter.agent.length === 0) {
                        api.post('/callrecordingreport', requestBody)
                            .then(response => {
                                resolve(response.data.data);
                            }).catch(function (error) {
                                resolve(error);
                            })
                    } else {
                        agent = state.filter.agent;
                        api.post('/callrecordingreport', requestBody)
                            .then(response => {
                                resolve(response.data.data);
                            }).catch(function (error) {
                                resolve(error);
                            })
                    }
                } catch (error) {
                    reject(error);
                }
            })
        }

        if (payload.misseddetail == 'exportdropedcalldetails') {
            return new Promise((resolve, reject) => {
                try {

                    let current_time = moment(new Date()).format().split('T')[1].split('+')[0]
                    from_date = state.filters.fromdate;
                    to_date = state.filters.todate;
                    if (from_date.length == 10) {
                        from_date += ' ' + current_time;
                    }
                    if (to_date.length == 10) {
                        to_date += ' ' + current_time;
                    }
                    // agent = state.filter.agent;
                    let agent = '';
                    let queue = '';
                    const campaigns = JSON.parse(localStorage.getItem("Team"));
                    let team_user = ''
                    if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
                    }
                    else {
                        let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
                        team_user = groupUsers.join(',');
                    }
                    agent = Array.isArray(state.filter.agent)
                        ? state.filter.agent.join(",")
                        : state.filter.agent || "";

                    queue = Array.isArray(state.filter.queue)
                        ? state.filter.queue.join(",")
                        : state.filter.queue || "";

                    const requestBody = {
                        from_date: from_date,
                        to_date: to_date,
                        agent: agent,
                        queue: queue,
                        extension: state.filter.extension,
                        phone_number: state.filter.phone || "",
                        uniqueid: state.filter.uniqueid || "",
                        team_user: team_user,
                    };
                    if (state.filter.agent === '' || state.filter.agent.length === 0) {

                        api.post("/dropedcallreports", requestBody)
                            .then(response => {
                                resolve(response.data.data);
                            }).catch(function (error) {
                                resolve(error);
                            })

                    } else {
                        api.post("/dropedcallreports", requestBody)
                            .then(response => {
                                resolve(response.data.data);
                            }).catch(function (error) {
                                resolve(error);
                            })
                    }
                } catch (error) {
                    commit(calldetails.DROPEDCALLDETAILS, []);
                    reject(error);
                }
            })
        }
        if (payload.misseddetail == 'exportmissedcalldetails') {
            return new Promise((resolve, reject) => {
                try {

                    from_date = state.filters.fromdate;
                    to_date = state.filters.todate;
                    const descending = payload.descending == null ? false : payload.descending;
                    let queue = '';
                    queue = Array.isArray(state.filter.queue)
                        ? state.filter.queue.join(",")
                        : state.filter.queue || "";
                    let campaign
                    let campaigns = JSON.parse(localStorage.getItem("Team"));
                    if (campaigns.length === 0) {
                        campaign = ""
                    }
                    else {
                        let campaigndata = [... new Set(campaigns.map((elm)=>{
                            return elm.campaign.map((campaign) => campaign.name);
                        }).flat())]
                        campaign = campaigndata.join(',');
                    }
                    const requestBody = {
                        fm_date_time: from_date,
                        to_date_time: to_date,
                        queue: queue,
                        phone: state.filter.phone || "",
                        descending: descending,
                        last_app: state.filters.last_app,
                        campaign: campaign
                    };
                    api.post('/missedcallreports', requestBody)
                        .then(response => {
                            resolve(response.data.data);
                        }).catch(function (error) {
                            resolve(error);
                        })
                } catch (error) {
                    reject(error);
                }
            })
        }

        if (payload.abandoncalldetail == 'exporteffectiveabandoncalldetails') {
            return new Promise((resolve, reject) => {
                try {
                    from_date = state.filters.fromdate;
                    to_date = state.filters.todate;
                    let queue = '';
                    queue = Array.isArray(state.filter.queue)
                        ? state.filter.queue.join(",")
                        : state.filter.queue;
                    let campaign
                    let campaigns = JSON.parse(localStorage.getItem("Team"));
                    if (campaigns.length === 0) {
                        campaign = ""
                    }
                    else {
                        let campaigndata = [... new Set(campaigns.map((elm)=>{
                            return elm.campaign.map((campaign) => campaign.name);
                        }).flat())]
                        campaign = campaigndata.join(',');
                    }
                    const requestBody = {
                        from_call_date: from_date,
                        to_call_date: to_date,
                        queue: queue,
                        phone: state.filter.phone,
                        campaign: campaign

                    };
                    api.post('/EffectiveAbandonfetch', requestBody)
                        .then(response => {
                            resolve(response.data);
                        }).catch(function (error) {
                            resolve(error);
                        })
                } catch (error) {
                    reject(error);
                }
            })
        }

        if (payload.misseddetail == 'AgentActivityReport') {
            return new Promise((resolve, reject) => {
                try {
                    const from_date = state.filters.fromdate;
                    const to_date = state.filters.todate;
                    let event = '';
                    let agent = '';
                    let team_user = '';
                    let eventdata = '';
                    let team = '';

                    // if (!state.filter.agent || state.filter.agent.length === 0) {
                        const campaigns = JSON.parse(localStorage.getItem("Team"));
                        if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
                        }
                        else if(campaigns.length > 0) {
                            let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
                            team_user = groupUsers.join(',');
                            team = campaigns.map(elm=> elm.name).join(',');  
                        }
                    // } else {
                    //     agent = state.filter.agent;
                    // }
                    const descending = payload.descending == null ? false : payload.descending;

                    agent = Array.isArray(state.filter.agent)
                        ? state.filter.agent.join(",")
                        : state.filter.agent || "";

                    eventdata = Array.isArray(payload.event_data)
                        ? payload.event_data.join(",")
                        : payload.event_data || "";

                    event = Array.isArray(state.filter.event)
                        ? state.filter.event.join(",")
                        : state.filter.event || "";


                    const requestBody = {
                        fm_date: from_date,
                        to_date: to_date,
                        agent: agent,
                        team_user: team_user,
                        campaign: state.filter.campaign || '',
                        event: event,
                        event_data: eventdata,
                        descending: descending,
                        team : team
                    };

                    if (state.filter.agent === '' || state.filter.agent.length === 0) {
                                            let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
                        api.post('/agentActivity', requestBody)
                            .then(response => {
                                console.log(response.data, "exportttttttttttttttttt", requestBody);

                                resolve(response.data.data);
                            }).catch(function (error) {
                                resolve(error);
                            })

                    } else {
                        agent = state.filter.agent;
                        api.post('/agentActivity', requestBody)
                            .then(response => {
                                console.log(response.data, "exportttttttttttttttttt222222222");

                                resolve(response.data.data);
                            }).catch(function (error) {
                                resolve(error);
                            })
                    }
                } catch (error) {
                    reject(error);
                }
            })
        }

        if (payload.misseddetail == 'AgentPauseReport') {
            return new Promise((resolve, reject) => {
                try {

                    from_date = state.filters.fromdate;
                    to_date = state.filters.todate;

                    let agent = '';
                    const campaigns = JSON.parse(localStorage.getItem("Team"));
                    let team_user = ''
                    if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
                    }
                    else {
                        let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
                        team_user = groupUsers.join(',');
                    }
                    agent = Array.isArray(state.filter.agent)
                        ? state.filter.agent.join(",")
                        : state.filter.agent || "";

                    const requestBody = {
                        fm_date: from_date,
                        to_date: to_date,
                        agent: agent,
                        team_user: team_user
                    };
                    if (state.filter.agent === '' || state.filter.agent.length === 0) {
                        api.post('/break/report', requestBody)
                            .then(response => {
                                resolve(response.data.data);
                                console.log(response.data.data);

                            }).catch(function (error) {
                                resolve(error);
                            })
                    } else {
                        api.post('/break/report', requestBody)
                            .then(response => {
                                resolve(response.data.data);
                                console.log(response.data.data);

                            }).catch(function (error) {
                                resolve(error);
                            })
                    }
                } catch (error) {
                    reject(error);
                }
            })
        }


        if (payload.misseddetail == 'AgentDispoReport') {
            return new Promise((resolve, reject) => {
                try {

                    from_date = state.filters.fromdate;
                    to_date = state.filters.todate;

                    let agent = '';
                    let team_user = ''
                    let team = ''
                    const campaigns = JSON.parse(localStorage.getItem("Team"));
                    if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
                    }
                    else if(campaigns.length > 0) {
                        let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
                        team_user = groupUsers.join(',');
                        team = campaigns.map(elm=> elm.name).join(',');    
                    }
                    agent = Array.isArray(state.filter.agent)
                        ? state.filter.agent.join(",")
                        : state.filter.agent || "";

                    let requestBody = {};
                    if (state.filter.agent === '' || state.filter.agent.length === 0) {
                        requestBody = {
                            fm_date: from_date,
                            to_date: to_date,
                            agent: agent,
                            team_user: team_user,
                            team:team

                        };
                        api.post('/dispo/report', requestBody)
                            .then(response => {
                                resolve(response.data.data);
                            }).catch(function (error) {
                                resolve(error);
                            })
                    } else {
                        requestBody = {
                            fm_date: from_date,
                            to_date: to_date,
                            agent: agent,
                            team_user: team_user
                        };
                        api.post('/dispo/report', requestBody)
                            .then(response => {
                                resolve(response.data.data);
                            }).catch(function (error) {
                                resolve(error);
                            })
                    }
                } catch (error) {
                    reject(error);
                }
            })
        }

        if (payload.misseddetail == 'hourlyPerformancereport') {
            const from_date = payload.from_date || '';
            const to_date = payload.to_date || '';
            const descending = payload.descending == null ? false : payload.descending;
            let agent = '';
            let team_user = JSON.parse(localStorage.getItem("Team_agent_user"))
            team_user = Array.isArray(team_user) ? team_user.join(',') : team_user;
            let team = '';
               
            team = Array.isArray(payload.team_name) ? payload.team_name.join(',') : payload.team_name;
            agent = Array.isArray(payload.selectedagent)
                ? payload.selectedagent.join(",")
                : payload.selectedagent || "";
            const requestBody = {
                fromdate: from_date,
                todate: to_date,
                fromtime: payload.fromtime,
                totime: payload.totime === "" ? 24 : payload.totime,
                agent: agent,
                team_user: team_user,
                campaign: state.filter.campaign || payload.campaign,
                // take: payload.take || 0,
                // skip: payload.skip || 0,
                descending: descending,
                team: team,
            };

            return new Promise((resolve, reject) => {
                try {
                    api.post('/agentPerformance/hourlyreport', requestBody)
                        .then(response => {
                            
                            resolve(response.data.data);
                        })
                        .catch(error => {
                            commit(calldetails.Performance_report, []);
                            resolve(error);
                        });
                } catch (error) {
                    commit(calldetails.Performance_report, []);
                    reject(error);
                }
            });
        }
        if (payload.misseddetail == 'Performancereport') {
            return new Promise((resolve, reject) => {
                try {
                    from_date = state.filters.fromdate;
                    to_date = state.filters.todate;
                    let agent = '';
                    const campaigns = JSON.parse(localStorage.getItem("Team"));
                    let team_user = ''
                    if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
                    }
                    else {
                        let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
                        team_user = groupUsers.join(',');
                    }
                    let team = '';
                    team = Array.isArray(payload.team_name) ? payload.team_name.join(',') : payload.team_name;
                    agent = Array.isArray(state.filter.agent)
                        ? state.filter.agent.join(",")
                        : state.filter.agent || "";
                    const requestBody = {
                        fromdate: from_date,
                        todate: to_date,
                        agent: agent,
                        team_user: team_user,
                        campaign: state.filter.campaign || '',
                        report_type: payload.report_type || '',
                        team: team,
                    };
                    if (state.filter.agent === '' || state.filter.agent.length === 0) {
                        api.post('/agentPerformance', requestBody)
                            .then(response => {
                                resolve(response.data.data);
                            }).catch(function (error) {
                                resolve(error);
                            })

                    } else {
                        agent = state.filter.agent;
                        api.post('/agentPerformance', requestBody)
                            .then(response => {
                                resolve(response.data.data);
                            }).catch(function (error) {
                                resolve(error);
                            })
                    }
                } catch (error) {
                    reject(error);
                }
            })
        }
        if (payload.misseddetail == 'system_call_summary') {
            return new Promise((resolve, reject) => {
                try {
                    from_date = state.filters.fromdate;
                    to_date = state.filters.todate;
                    let campaign
                    let campaigns = JSON.parse(localStorage.getItem("Team"));
                    if (campaigns.length === 0) {
                        campaign = ""
                    }
                    else {
                        let campaigndata = [... new Set(campaigns.map((elm)=>{
                            return elm.campaign.map((campaign) => campaign.name);
                        }).flat())]
                        campaign = campaigndata.join(',');
                    }
                    const requestBody = {
                        fromdate: from_date,
                        todate: to_date,
                        datetype: payload.datetype,
                        campaign: campaign
                    };
                    api.post('/CallSummary_fetch', requestBody)
                        .then(response => {
                            resolve(response.data.data);
                        }).catch(function (error) {
                            resolve(error);
                        })

                } catch (error) {
                    reject(error);
                }
            })
        }




        if (payload.misseddetail == 'exportQueuSummaryReport') {
            return new Promise((resolve, reject) => {
                try {
                    // from_date = state.filters.fromdate;
                    // to_date = state.filters.todate;
                    let queue = '';
                    queue = Array.isArray(state.filter.queue)
                        ? state.filter.queue.join(",")
                        : state.filter.queue || "";
                    let campaign
                    let campaigns = JSON.parse(localStorage.getItem("Team"));
                    if (campaigns.length === 0) {
                        campaign = ""
                    }
                    else {
                        let campaigndata = [... new Set(campaigns.map((elm)=>{
                            return elm.campaign.map((campaign) => campaign.name);
                        }).flat())]
                        campaign = campaigndata.join(',');
                    }

                    const requestBody = {
                        fromdate: state.filters.fromdate,
                        todate: state.filters.todate,
                        queue: queue,
                        campaign: campaign
                    }
                    api.post('/queueSummary', requestBody)
                        .then(response => {
                            resolve(response.data.data);
                        }).catch(function (error) {
                            resolve(error);
                        })
                } catch (error) {
                    reject(error);
                }
            })
        }
        if (payload.calldetail == 'exportCallTransferDetails') {
            return new Promise((resolve, reject) => {
                try {
                    const from_date = state.filters.fromdate;
                    const to_date = state.filters.todate;
                    let agent = '';
                    const campaigns = JSON.parse(localStorage.getItem("Team"));
                    let team_user = ''
                    if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
                    }
                    else {
                        let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
                        team_user = groupUsers.join(',');
                    }
                    agent = Array.isArray(state.filter.agent)
                        ? state.filter.agent.join(",")
                        : state.filter.agent || "";
                    const requestBody = {
                        from_call_date: from_date,
                        to_call_date: to_date,
                        agent: agent,
                        team_user: team_user,
                        uniqueid: state.filter.uniqueid || "",
                    };
                    api.post("/Call-transfer-fetch", requestBody)
                        .then(response => resolve(response.data.data))
                        .catch(error => resolve(error));
                } catch (error) {
                    reject(error);
                }
            });
        }
    },

    recordingdetails({ commit, state }, payload) {
        from_date = state.filters.fromdate;
        to_date = state.filters.todate;
        let agent = '';
        let calltype = '';
        const campaigns = JSON.parse(localStorage.getItem("Team"));
        let team_user = ''
        if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
        }
        else {
            let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
            team_user = groupUsers.join(',');
        }

        let team = '';
        team = Array.isArray(payload.team_name) ? payload.team_name.join(',') : payload.team_name;
        agent = Array.isArray(state.filter.agent)
            ? state.filter.agent.join(",")
            : state.filter.agent || "";

        calltype = Array.isArray(state.filter.type)
            ? state.filter.type.join(",")
            : state.filter.type || "";

        const requestBody = {
            fromdate: from_date,
            todate: to_date,
            campaign: state.filter.campaign,
            station: state.filter.station,
            phone_number: state.filter.phone,
            call_type: calltype,
            team_user: team_user,
            agent: agent,
            calltrans:payload.calltrans,
            skip: payload.skip,
            take: payload.take,
            descending: payload.descending,
            uniqueid: state.filter.uniqueid,
            operator: payload.operator,
            value: payload.value,
            dispo: payload.dispo,
            subdispo: payload.subdispo,
            team: team

        }
        return new Promise((resolve, reject) => {
            try {

                api.post('/callrecordingreport', requestBody)
                    .then(response => {
                        commit(calldetails.RECORDINGDETAILS, response.data.data);
                        resolve(response.data)
                    }).catch(function (error) {
                        // commit(calldetails.RECORDINGDETAILS, error);
                        resolve(error)
                    });

            } catch (error) {
                // commit(calldetails.RECORDINGDETAILS, error);
                reject(error);
            }
        })
    },
    queueSummaryReport({ commit }, payload) {
        return new Promise((resolve, reject) => {
            try {
                if (payload.descending == null) {
                    payload.descending = false;
                }
                let queue = '';
                queue = Array.isArray(state.filter.queue)
                    ? state.filter.queue.join(",")
                    : state.filter.queue;
                let campaign
                let campaigns = JSON.parse(localStorage.getItem("Team"));
                if (campaigns.length === 0) {
                    campaign = ""
                }
                else {
                    let campaigndata = [... new Set(campaigns.map((elm)=>{
                        return elm.campaign.map((campaign) => campaign.name);
                    }).flat())]
                    campaign = campaigndata.join(',');
                }
                const requestBody = {
                    fromdate: state.filters.fromdate,
                    todate: state.filters.todate,
                    queue: queue,
                    descending: payload.descending,
                    take: payload.take,
                    skip: payload.skip,
                    campaign: campaign
                }
                api.post('/queueSummary', requestBody)
                    .then(response => {
                        commit(calldetails.queueSummaryReport, response.data.data);
                        resolve(response.data)
                    }).catch(function (error) {
                        commit(calldetails.Performance_report, error);
                        resolve(error)
                    });

            } catch (error) {
                commit(calldetails.Performance_report, error);
                reject(error);
            }
        })

    },
    HourlyPerformancereport({ commit }, payload) {
        console.log(payload,"pppppppppppppp")
        const from_date = payload.from_date || '';
        const to_date = payload.to_date || '';
        const descending = payload.descending == null ? false : payload.descending;
        let agent = '';
        let team_user =  JSON.parse(localStorage.getItem("Team_agent_user"))
        team_user = Array.isArray(team_user) ? team_user.join(',') : team_user;
        let team = '';
        team = Array.isArray(payload.team_name) ? payload.team_name.join(',') : payload.team_name;
        agent = Array.isArray(payload.selectedagent)
            ? payload.selectedagent.join(",")
            : payload.selectedagent || "";
        const requestBody = {
            fromdate: from_date,
            todate: to_date,
            fromtime: payload.fromtime,
            totime: payload.totime === "" ? 24 : payload.totime,
            agent: agent,
            team_user: team_user,
            campaign: state.filter.campaign || payload.campaign,
            take: payload.take || 0,
            skip: payload.skip || 0,
            descending: descending,
            team: team,
        };

        return new Promise((resolve, reject) => {
            try {
                api.post('/agentPerformance/hourlyreport', requestBody)
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(error => {
                        commit(calldetails.Performance_report, []);
                        resolve(error);
                    });
            } catch (error) {
                commit(calldetails.Performance_report, []);
                reject(error);
            }
        });
    },
    Performancereport({ commit }, payload) {
       
        const from_date = state.filters.fromdate || '';
        const to_date = state.filters.todate || '';
        const descending = payload.descending == null ? false : payload.descending;
        let agent = '';
        const campaigns = JSON.parse(localStorage.getItem("Team"));
        let team_user = ''
        if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
        }
        else {
            let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
            team_user = groupUsers.join(',');
        }
        let team = '';
        team = Array.isArray(payload.team_name) ? payload.team_name.join(',') : payload.team_name;
        agent = Array.isArray(state.filter.agent)
            ? state.filter.agent.join(",")
            : state.filter.agent || "";
        const requestBody = {
            fromdate: from_date,
            todate: to_date,
            agent: agent,
            team_user: team_user,
            campaign: state.filter.campaign || '',
            take: payload.take || 0,
            skip: payload.skip || 0,
            descending: descending,
            report_type: payload.report_type || '',
            team: team,
        };

        return new Promise((resolve, reject) => {
            try {
                api.post('/agentPerformance', requestBody)
                    .then(response => {
                        commit(calldetails.Performance_report, response.data.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        commit(calldetails.Performance_report, []);
                        resolve(error);
                    });
            } catch (error) {
                commit(calldetails.Performance_report, []);
                reject(error);
            }
        });
    },
    audioplay({ commit }, payload) {
        return new Promise((resolve, reject) => {
            try {
                api.get("recordingUrl?tenant_code=" + payload.tid + "&date=" + payload.date + "&id=" + payload.id).then(response => {
                    resolve(response.data)
                }).catch(function (error) {
                    resolve(error)
                });

            } catch (error) {
                commit(calldetails.RECORDINGDETAILS, error);
                reject(error);
            }
        })

    },

    reporttemplatelist: () => {
        api.get("TempListFetch").then(response => {
            var Templist = response.data.data;
            var Temp_list = [];
            for (var i = 0; i < Templist.length; i++) {
                Temp_list.push(Templist[i].template_name)
            }
            localStorage.setItem("group_template", JSON.stringify(Temp_list));

        })
    },

    // reportuserlist: ({ dispatch, commit }) => {
    //   // var userList = [];
    //   // api.get("userList").then(response => {
    //   //   var user_response = response.data.data;
    //   //   for (var i = 0; i < user_response.length; i++) {
    //   //     if (user_response[i].agent != '') {
    //   //       userList.push(user_response[i].agent)
    //   //     }
    //   //   }
    //   //   commit(calldetails.AGENT_LISTS, userList);
    //   // })
    //   let data = localStorage.getItem('groupId');
    //   dispatch('getGroupUserLists', data).then(response => {
    //     commit(calldetails.AGENT_LISTS, response);
    //     // resolve(response.data.data)
    //   })
    // },
    // reportuserlist: ({ dispatch }) => {
    //     return new Promise((resolve, reject) => {
    //         try {
    //             let data = localStorage.getItem('groupId');
    //             dispatch('getGroupUserLists', data).then(response => {
    //                     resolve(response);
    //                 })
    //                 .catch(function(error) {
    //                     // commit(calldetails.RECORDINGDETAILS, error);
    //                     reject(error)
    //                 });

    //         } catch (error) {
    //             // commit(calldetails.RECORDINGDETAILS, error);
    //             reject(error);
    //         }
    //     })
    // },
    ReportcampaignList: ({ commit }) => {
        api.get("campaignList").then(response => {
            var data_response = response;
            commit(calldetails.CAMPAIGN_LISTS, data_response);
        })
    },

    ticketbyDate({ commit }, payload) {
        from_date = state.filters.fromdate;
        to_date = state.filters.todate;
        return new Promise((resolve, reject) => {
            try {
                if (payload.descending == null) {
                    payload.descending = false;
                }
                api.get("/ticket/date?fromDate=" + from_date + "&toDate=" + to_date).then(response => {
                    commit(calldetails.TicketReport, response.data.data);
                    resolve(response.data)
                }).catch(function (error) {
                    commit(calldetails.TicketReport, []);
                    resolve(error)
                });
            } catch (error) {
                commit(calldetails.TicketReport, []);
                reject(error);
            }
        })
    },

    ticketbyAgent({ commit }, payload) {
        return new Promise((resolve, reject) => {
            try {
                from_date = state.filters.fromdate;
                to_date = state.filters.todate;
                // let agent = '';
                // agent = Array.isArray(payload.agent)
                // ? payload.agent.join(",")
                // : payload.agent || "";
                let query = ""

                if (payload.agent) {
                    query = `${payload.agent}`
                }


                if (payload.descending == null) {
                    payload.descending = false;
                }
                const campaigns = JSON.parse(localStorage.getItem("Team"));
                let team_user = ''
                if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
                }
                else {
                    let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
                    team_user = groupUsers.join(',');
                }
                const requestBody = {
                    fromDate: from_date,
                    toDate: to_date,
                    user: query,
                    team_user: team_user
                }
                api.post('/ticket/user', requestBody)
                    .then(response => {
                        commit(calldetails.TicketReport, response.data.data);
                        resolve(response.data)
                    }).catch(function (error) {
                        commit(calldetails.TicketReport, []);
                        resolve(error)
                    });
            } catch (error) {
                commit(calldetails.TicketReport, []);
                reject(error);
            }
        })
    },

    watsAppbyDate({ commit }, payload) {
        from_date = state.filters.fromdate;
        to_date = state.filters.todate;
        return new Promise((resolve, reject) => {
            try {
                if (payload.descending == null) {
                    payload.descending = false;
                }
                api.get("/ticket/wa_date?fromDate=" + from_date + "&toDate=" + to_date).then(response => {
                    console.log(response)
                    commit(calldetails.WatsAppReport, response.data.data);
                    resolve(response.data)
                }).catch(function (error) {
                    commit(calldetails.MISSEDCALLDETAILS, []);
                    resolve(error)
                });
            } catch (error) {
                commit(calldetails.MISSEDCALLDETAILS, []);
                reject(error);
            }
        })
    },

    watsAppbyAgent({ commit }, payload) {
        from_date = state.filters.fromdate;
        to_date = state.filters.todate;
        let query = ""

        if (payload.agent) {
            query = `&user=${payload.agent}`
        }
        return new Promise((resolve, reject) => {
            try {
                if (payload.descending == null) {
                    payload.descending = false;
                }
                api.get("/ticket/wa_user?fromDate=" + from_date + "&toDate=" + to_date + query).then(response => {
                    console.log(response)
                    commit(calldetails.WatsAppReport, response.data.data);
                    resolve(response.data)
                }).catch(function (error) {
                    commit(calldetails.WatsAppReport, []);
                    resolve(error)
                });
            } catch (error) {
                commit(calldetails.WatsAppReport, []);
                reject(error);
            }
        })
    },

    recurl({ commit }, payload) {
        return new Promise((resolve, reject) => {
            try {
                api.get(`/callactivity/recordurl?id=${payload}`).then(response => {
                    resolve(response.data.data)
                }).catch(function (error) {
                    resolve(error)
                });

            } catch (error) {
                commit(calldetails.RECORDINGDETAILS, error);
                reject(error);
            }
        })

    },
    recordingreportscomments(_, payload) {

        return new Promise((resolve, reject) => {
            try {
                api.post("recording", payload).then(response => {

                    resolve(response)
                }).catch(function (error) {

                    resolve(error)
                });

            } catch (error) {
                // commit(calldetails.RECORDINGDETAILS, error);
                reject(error);
            }
        })
    },
    reportSubdispo({ commit }) {
        return new Promise((resolve, reject) => {
            api.get("/subdisposition?take=100").then(res => {
                let subdispo = []
                if (res.status == 200) {
                    if (res.data.data.length > 0) {
                        res.data.data.forEach(elm => {
                            if (elm.active == "Y") {
                                subdispo.push({ dispo: elm.dispo_id, subdispo: elm.subdispo_id })
                            }
                        })
                    }
                }
                commit(calldetails.SUBDISPOSITION_LIST, subdispo);
                resolve(res)
            }).catch(function (error) {
                console.log(error)
                resolve(reject)
            });
        })
    },
    reportDispo({ commit }) {
        return new Promise((resolve, reject) => {
            api.get("/disposition?take=").then(response => {
                let dispo = []
                if (response.status == 200) {
                    if (response.data.data.length > 0) {
                        response.data.data.forEach(element => {
                            if (element.active == "Y") {
                                dispo.push(element.dispo_id)

                            }
                        });
                    }

                }
                commit(calldetails.DISPOSITION_LIST, dispo);
                resolve(response)
            }).catch(function (error) {
                console.log(error)
                resolve(reject)
            });
        })
    },
    async callTransferDetails({ commit, state }, payload) {
        const from_date = state.filters.fromdate;
        const to_date = state.filters.todate;

        let agent = '';
        const uniqueid = state.filter.uniqueid || '';
        const campaigns = JSON.parse(localStorage.getItem("Team"));
        let team_user = ''
        if (campaigns.length === 0) {
                    let agent_emails = JSON.parse(localStorage.getItem("agent_emails"))
                    team_user = agent_emails.join(',');
        }
        else {
            let groupUsers = JSON.parse(localStorage.getItem("Team_agent_user"));
            team_user = groupUsers.join(',');
        }
        agent = Array.isArray(state.filter.agent)
            ? state.filter.agent.join(",")
            : state.filter.agent || "";
        const requestBody = {
            from_call_date: from_date,
            to_call_date: to_date,
            agent: agent,
            uniqueid: uniqueid,
            team_user: team_user,
            take: payload.take || 10,
            skip: payload.skip || 0,
        };

        try {
            const response = await api.post('/Call-transfer-fetch', requestBody);
            commit(calldetails.CALLDETAILS, response.data.data);
            return response.data;
        }
        catch (error) {
            commit(calldetails.CALLDETAILS, []);
            return error;
        }
    },
};

export default {
    state,
    getters,
    mutations,
    actions
};